import { pastBookingUtils } from "@flights/web-api-utils-universal";
export const getFilteredLegsWithOpenedCheckIn = (flightSegments, carrierCheckinInfo) => {
    let nextLegIsVi = false;
    const filteredLegs = [];
    flightSegments.some((segment, segmentIndex) => {
        if (pastBookingUtils.isFlightSegmentInThePast(segment)) {
            return;
        }
        segment.legs.forEach((leg, legIndex) => {
            if (nextLegIsVi || legIndex === 0) {
                const checkinInfoForLeg = carrierCheckinInfo?.find((checkinInfo) => checkinInfo.legIdentifier.segmentIndex === segmentIndex && checkinInfo.legIdentifier.legIndex === legIndex);
                if (checkinInfoForLeg) {
                    filteredLegs.push({ leg, checkinInfoForLeg });
                }
            }
            nextLegIsVi = !!leg.vi?.protected;
        });
        return true;
    });
    return filteredLegs;
};
